import React from "react";
import {Card} from "../modules/LedgerAccounts/index";

export function LedgerAccountsCardPage(props) {
  return (
    <Card {...props} />
  );
}
